import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

declare global {
  interface Window {
    __VS_APP_MOUNTED__?: boolean;
  }
}

// Remove PWA splash screen after React loads
const removeSplash = () => {
  const splash = document.getElementById('pwa-splash');
  if (splash) {
    splash.style.transition = 'opacity 0.3s ease-out';
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 300);
  }
};

try {
  createRoot(document.getElementById("root")!).render(<App />);
  window.__VS_APP_MOUNTED__ = true;

  // Remove splash after a short delay to ensure content is rendered
  setTimeout(removeSplash, 100);
} catch (err) {
  // If React fails to boot (e.g., cached old assets on mobile), keep splash and show reload hint.
  const text = document.getElementById('pwa-loading-text');
  const btn = document.getElementById('pwa-reload-btn');
  if (text) text.textContent = 'লোডিং সমস্যা হচ্ছে। রিলোড দিন।';
  if (btn) (btn as HTMLButtonElement).style.display = 'inline-flex';
  // eslint-disable-next-line no-console
  console.error('App bootstrap failed:', err);
}
